import InvoiceTransplant from './transplant-invoices';
import ApSbsReport from './ap-sbs';
import Tabs from './nav';
import OpoPayable from './opo-payable';
import { DonorEvalQuery } from '@nkr/enums/donor-eval-query';
import DonorEvalReport from './donor-eval/donor-eval-report';

interface IProps {
    tabKey: string,
    subTabKey: string
}

const Invoice = (props: IProps) => {
    return (
        <>
            <Tabs
                tabKey={props.tabKey}
                subTabKey={props.subTabKey}
            />

            {props.tabKey == 'PAYABLE' && (
                <>
                    {props.subTabKey == "NEPHRECTOMY" && <ApSbsReport />}

                    {props.subTabKey == "EVAL" && <DonorEvalReport />}

                    {props.subTabKey == "PACKAGING" && <OpoPayable />}
                </>
            )}

            {props.tabKey == 'INVOICING' && (
                <InvoiceTransplant
                    subTab={props.subTabKey}
                />
            )}
        </>
    );
}

export default Invoice;